module.exports = __webpack_public_path__ + "static/write2congressReactG-03b679563f4cb2d90346715b538024f2.gif";